import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import Dropdown from './Dropdown';
import { filterComponentStyles } from '../../css/style';
import { orderPaginationCount } from '../../data/Constants';
import * as Functions from '../../utils/Functions';

const styles = filterComponentStyles();

class Filter extends Component {
  getPaginationCount = () => {
    const { match } = this.props;
    const { resource } = match.params;
    let paginationCount;
    if (resource === 'orders') {
      paginationCount = orderPaginationCount;
    }
    return paginationCount;
  }

  onChangeSelectedOption = (event) => {
    const {
      match,
      updateParentState,
      dropdownOptions,
      dropdownType,
    } = this.props;
    const { resource } = match.params;
    const selected = Functions.getSelectedOptions(event, dropdownOptions);
    this.setState({ selectedOption: selected }, async () => {
      const parentStateKey = dropdownType === 'deliveryOption' ? 'orderType' : dropdownType;
      updateParentState(parentStateKey, selected);
    });
  };

  render() {
    const {
      dropdownTitle, dropdownOptions, selectedOption, actions, dropdownType,
    } = this.props;
    return (
      <div style={styles.filterContainer}>
        <Dropdown
          dropdownType={dropdownType}
          onChange={event => this.onChangeSelectedOption(event)}
          dropdownOptions={dropdownOptions}
          actions={actions}
          data={this.state !== null ? this.state.selectedOption : selectedOption}
          style={styles.v2DropdownContainer}
        />
      </div>
    );
  }
}

Filter.propTypes = {
  dropdownTitle: PropTypes.string.isRequired,
  dropdownOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedOption: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.objectOf(PropTypes.any),
  ]).isRequired,
  updateParentState: PropTypes.func.isRequired,
  actions: PropTypes.objectOf(PropTypes.any).isRequired,
  apiToken: PropTypes.string.isRequired,
};

export default withRouter(Filter);
